/**
 * KolonConfig'den Yükleme Cetveli verisi üretir.
 * TestPanel'de simpleSupply olmadığında kullanılır.
 */

// Standart daire (mesken) branch circuit'leri
function createDaireBranchCircuits(panelId, daireFaz) {
  const is3Faz = daireFaz === '3 Faz';
  return [
    { id: `${panelId}-bc1`, type: 'socket', sorti: 6, totalPower: 3000, phaseName: 'r', phaseCount: 1, notrSectionIsEqual: true, description: 'Priz Linyesi', breaker: { curve: 'B', current: 16, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
    { id: `${panelId}-bc2`, type: 'socketDish', sorti: 1, totalPower: 2200, phaseName: 's', phaseCount: 1, notrSectionIsEqual: true, description: 'Bulaşık Makinesi', breaker: { curve: 'C', current: 16, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
    { id: `${panelId}-bc3`, type: 'socketWash', sorti: 1, totalPower: 2200, phaseName: 't', phaseCount: 1, notrSectionIsEqual: true, description: 'Çamaşır Makinesi', breaker: { curve: 'C', current: 16, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
    { id: `${panelId}-bc4`, type: 'socketOven', sorti: 1, totalPower: 3000, phaseName: 'rst', phaseCount: 3, notrSectionIsEqual: true, description: 'Fırın', breaker: { curve: 'C', current: 20, polar: 3, shortCircuitCurCap: 3, type: 'AOS' } },
    { id: `${panelId}-bc5`, type: 'socketAirCond', sorti: 1, totalPower: 2500, phaseName: 'r', phaseCount: 1, notrSectionIsEqual: true, description: 'Klima', breaker: { curve: 'C', current: 16, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
    { id: `${panelId}-bc6`, type: 'light', sorti: 5, totalPower: 500, phaseName: 's', phaseCount: 1, notrSectionIsEqual: false, description: 'Aydınlatma Linyesi', breaker: { curve: 'B', current: 10, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
    { id: `${panelId}-bc7`, type: 'light', sorti: 4, totalPower: 400, phaseName: 't', phaseCount: 1, notrSectionIsEqual: false, description: 'Aydınlatma Linyesi', breaker: { curve: 'B', current: 10, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
  ];
}

// Faz dağılımı hesapla
function calculatePhases(branchCircuits) {
  let r = 0, s = 0, t = 0, rst = 0;
  branchCircuits.forEach(bc => {
    if (bc.phaseName === 'r') r += bc.totalPower;
    else if (bc.phaseName === 's') s += bc.totalPower;
    else if (bc.phaseName === 't') t += bc.totalPower;
    else if (bc.phaseName === 'rst') rst += bc.totalPower;
  });
  return { r, s, t, rst };
}

export function generateYCDataFromKolonConfig(kolonConfig, tumKatlar) {
  const katBasiDaire = parseInt(kolonConfig.katBasiDaire) || 4;
  const daireFaz = kolonConfig.daireFaz || '1 Faz';
  const panels = [];

  // --- G.T. (Genel Tablo / Müşterek) ---
  if (kolonConfig.musterek) {
    const merdivenCikis = parseInt(kolonConfig.gtMerdivenCikis) || 3;
    const asansorCikis = parseInt(kolonConfig.gtAsansorCikis) || 1;
    const merdivenArmatur = parseInt(kolonConfig.gtMerdivenArmatur) || 4;
    const asansorArmatur = parseInt(kolonConfig.gtAsansorArmatur) || 4;

    const gtBC = [];
    const phases = ['r', 's', 't'];

    for (let i = 1; i <= merdivenCikis; i++) {
      gtBC.push({
        id: `gt-mrd-${i}`, type: 'light', sorti: merdivenArmatur,
        totalPower: merdivenArmatur * 50,
        phaseName: phases[(i - 1) % 3], phaseCount: 1, notrSectionIsEqual: false,
        description: `${i}. Merdiven Aydınlatma`,
        breaker: { curve: 'B', current: 10, polar: 1, shortCircuitCurCap: 3, type: 'AOS' },
      });
    }
    for (let i = 1; i <= asansorCikis; i++) {
      gtBC.push({
        id: `gt-asn-${i}`, type: 'light', sorti: asansorArmatur,
        totalPower: asansorArmatur * 40,
        phaseName: phases[(merdivenCikis + i - 1) % 3], phaseCount: 1, notrSectionIsEqual: false,
        description: `${i}. Asansör Aydınlatma`,
        breaker: { curve: 'B', current: 10, polar: 1, shortCircuitCurCap: 3, type: 'AOS' },
      });
    }
    gtBC.push({
      id: 'gt-priz', type: 'socket', sorti: 2, totalPower: 500,
      phaseName: 's', phaseCount: 1, notrSectionIsEqual: true,
      description: 'Priz Linyesi',
      breaker: { curve: 'B', current: 16, polar: 1, shortCircuitCurCap: 3, type: 'AOS' },
    });
    gtBC.push({
      id: 'gt-za', type: 'lowCurrent', sorti: 1, totalPower: 100,
      phaseName: 't', phaseCount: 1, notrSectionIsEqual: false,
      description: 'Zayıf Akım',
      breaker: { curve: 'B', current: 6, polar: 1, shortCircuitCurCap: 3, type: 'AOS' },
    });

    const gtInstalled = gtBC.reduce((s, bc) => s + bc.totalPower, 0);
    const gtPhases = calculatePhases(gtBC);

    panels.push({
      name: 'G.T.',
      id: 'panel-gt',
      floorName: kolonConfig.girisKati || 'Zemin Kat',
      floorNumber: 99,
      installedPower: gtInstalled,
      demandPower: gtInstalled,
      demandFactor: '100-50',
      phase: 'rst', phaseCount: 3,
      subscribeType: 'Müşterek',
      type: 'panel', isMainPanel: false,
      cableTitle: '5x6mm² NYM-J',
      cableCurrentLimit: 40,
      cableCurrentCarryType: 'pipe',
      panelMainBreaker: { curve: 'C', current: 32, polar: 4, shortCircuitCurCap: 3, type: 'AOS' },
      rcd: { current: 40, sensitivity: 300, curve: 'AC', pole: '4P', polar: 4, title: '4P-40A-300mA' },
      branchCircuits: gtBC,
      phases: gtPhases,
      meterBreaker: 'C-4x32A',
      current: (gtInstalled / 526).toFixed(2),
    });
  }

  // --- ASANSÖR ---
  if (kolonConfig.asansor) {
    const asansorW = (parseInt(kolonConfig.asansorGucu) || 15) * 1000;
    const asansorBC = [
      { id: 'asn-motor', type: 'socketMotor', sorti: 1, totalPower: asansorW, phaseName: 'rst', phaseCount: 3, notrSectionIsEqual: true, description: 'Asansör Motoru', breaker: { curve: 'C', current: 40, polar: 3, shortCircuitCurCap: 6, type: 'AOS' } },
      { id: 'asn-ayd', type: 'light', sorti: 2, totalPower: 200, phaseName: 'r', phaseCount: 1, notrSectionIsEqual: false, description: 'Kabin Aydınlatma', breaker: { curve: 'B', current: 10, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
      { id: 'asn-priz', type: 'socket', sorti: 1, totalPower: 500, phaseName: 's', phaseCount: 1, notrSectionIsEqual: true, description: 'Priz', breaker: { curve: 'B', current: 16, polar: 1, shortCircuitCurCap: 3, type: 'AOS' } },
    ];
    const asansorTotal = asansorBC.reduce((s, bc) => s + bc.totalPower, 0);

    panels.push({
      name: 'ASANSÖR',
      id: 'panel-asansor',
      floorName: kolonConfig.enerjiOdasiKati || 'Zemin Kat',
      floorNumber: 98,
      installedPower: asansorTotal,
      demandPower: asansorTotal,
      demandFactor: '100',
      phase: 'rst', phaseCount: 3,
      subscribeType: 'Asansör',
      type: 'panel', isMainPanel: false,
      cableTitle: '5x10mm² NYM-J',
      cableCurrentLimit: 50,
      cableCurrentCarryType: 'pipe',
      panelMainBreaker: { curve: 'C', current: 40, polar: 4, shortCircuitCurCap: 6, type: 'AOS' },
      rcd: { current: 63, sensitivity: 300, curve: 'AC', pole: '4P', polar: 4, title: '4P-63A-300mA' },
      branchCircuits: asansorBC,
      phases: calculatePhases(asansorBC),
      meterBreaker: 'C-4x40A',
      current: (asansorTotal / 526).toFixed(2),
    });
  }

  // --- Daire Panelleri (kat başına katBasiDaire adet) ---
  // Her kat için ayrı panel seti oluştur
  const katlarYukaridan = [...tumKatlar].reverse(); // üst kattan alt kata

  katlarYukaridan.forEach((katName, katIdx) => {
    for (let d = 1; d <= katBasiDaire; d++) {
      const panelId = `nkt-${katIdx}-${d}`;
      const bc = createDaireBranchCircuits(panelId, daireFaz);
      const installed = bc.reduce((s, b) => s + b.totalPower, 0);
      const demandPower = Math.round(installed * 0.6);
      const ph = calculatePhases(bc);

      panels.push({
        name: `${katName} D.${d}`,
        id: panelId,
        floorName: katName,
        floorNumber: tumKatlar.length - katIdx - 1,
        installedPower: installed,
        demandPower: demandPower,
        demandFactor: '60-40',
        phase: 'rst',
        phaseCount: daireFaz === '3 Faz' ? 3 : 1,
        subscribeType: 'Mesken',
        type: 'panel', isMainPanel: false,
        cableTitle: '5x4mm² NYM-J',
        cableCurrentLimit: 32,
        cableCurrentCarryType: 'pipe',
        panelMainBreaker: { curve: 'C', current: 25, polar: 2, shortCircuitCurCap: 3, type: 'AOS' },
        rcd: { current: 40, sensitivity: 30, curve: 'AC', pole: '2P', polar: 2, title: '2P-40A-30mA' },
        branchCircuits: bc,
        phases: ph,
        meterBreaker: 'B-2x25A',
        current: (demandPower / 230).toFixed(2),
        cableCurrentCarryType: 'pipe',
      });
    }
  });

  // --- ADP hesapla ---
  const dairePanels = panels.filter(p => p.subscribeType === 'Mesken');
  const musterekPanels = panels.filter(p => p.subscribeType === 'Müşterek');
  const asansorPanels = panels.filter(p => p.subscribeType === 'Asansör');

  const daireTotalPower = dairePanels.reduce((s, p) => s + p.installedPower, 0);
  const daireDemandPower = dairePanels.reduce((s, p) => s + p.demandPower, 0);
  const musterekTotalPower = musterekPanels.reduce((s, p) => s + p.installedPower, 0);
  const musterekDemandPower = musterekPanels.reduce((s, p) => s + p.demandPower, 0);
  const asansorTotalPower = asansorPanels.reduce((s, p) => s + p.installedPower, 0);
  const asansorDemandPower = asansorPanels.reduce((s, p) => s + p.demandPower, 0);

  const totalInstalled = daireTotalPower + musterekTotalPower + asansorTotalPower;
  const totalDemand = daireDemandPower + musterekDemandPower + asansorDemandPower;
  const totalCurrent = (totalDemand / 526).toFixed(2);

  // Ana kesici seçimi (akıma göre)
  const currentVal = parseFloat(totalCurrent);
  let adpBreakerCurrent = 125;
  if (currentVal <= 63) adpBreakerCurrent = 63;
  else if (currentVal <= 80) adpBreakerCurrent = 80;
  else if (currentVal <= 100) adpBreakerCurrent = 100;
  else if (currentVal <= 125) adpBreakerCurrent = 125;

  // Ana kablo seçimi
  let adpCableTitle = '4x70mm² NYY-J';
  let adpCableCurrentLimit = 196;
  if (currentVal <= 40) { adpCableTitle = '4x16mm² NYY-J'; adpCableCurrentLimit = 68; }
  else if (currentVal <= 63) { adpCableTitle = '4x25mm² NYY-J'; adpCableCurrentLimit = 89; }
  else if (currentVal <= 80) { adpCableTitle = '4x35mm² NYY-J'; adpCableCurrentLimit = 110; }
  else if (currentVal <= 100) { adpCableTitle = '4x50mm² NYY-J'; adpCableCurrentLimit = 134; }

  const adp = {
    name: 'ADP',
    rcd: { current: adpBreakerCurrent, sensitivity: 300, curve: 'AC', pole: '4P', polar: 4, title: `4P-${adpBreakerCurrent}A-300mA` },
    breaker: { curve: 'C', current: adpBreakerCurrent, polar: 4, shortCircuitCurCap: 6, type: 'AOS' },
    cableTitle: adpCableTitle,
    cableCurrentLimit: adpCableCurrentLimit,
    cableCurrentCarryType: 'earth',
    current: totalCurrent,
    demandPower: totalDemand,
    installedTotalPower: totalInstalled,
    powers: {
      phases: {
        r: Math.round(totalDemand * 0.33),
        s: Math.round(totalDemand * 0.34),
        t: Math.round(totalDemand * 0.33),
        rst: 0
      },
      daireTotalPower: daireTotalPower > 0 ? `${daireTotalPower} W` : null,
      daireDemandFakt: dairePanels.length > 0 ? '60-40' : null,
      daireDemandPower: daireDemandPower > 0 ? `${daireDemandPower} W` : null,
      musterekTotalPower: musterekTotalPower > 0 ? `${musterekTotalPower} W` : null,
      musterekDemandFakt: musterekTotalPower > 0 ? '100-50' : null,
      musterekDemandPower: musterekDemandPower > 0 ? `${musterekDemandPower} W` : null,
      isyeriTotalPower: null,
      isyeriDemandFakt: null,
      isyeriDemandPower: null,
      asansorTotalPower: asansorTotalPower > 0 ? `${asansorTotalPower} W` : null,
      asansorDemandFakt: asansorTotalPower > 0 ? '100' : null,
      asansorDemandPower: asansorDemandPower > 0 ? `${asansorDemandPower} W` : null,
    },
  };

  return { panels, adp };
}
